const Languages = () => {
  return (
    <section className="languages">
      <h2 className="title-font  pink-text h2-tag">Languages</h2>
      <section>
        <section>
          <h3>English</h3>
          <p>Professional working proficiency</p>
          <h3>Urdu</h3>
          <p>Native or bilingual proficiency</p>
        </section>
      </section>
    </section>
  );
};

export default Languages;
